import { render, staticRenderFns } from "./Text2.vue?vue&type=template&id=c410f546&"
import script from "./Text2.vue?vue&type=script&lang=js&"
export * from "./Text2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports